import React, { type MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";
import { CloseIcon } from "@/icons";
import style from "./deletePastVoteWindow.module.css";

type DeletePastVoteWindowProps = {
    name: string;
    onClose: () => void;
    onDelete: () => void;
};

export function DeletePastVoteWindow({ name, onClose, onDelete }: DeletePastVoteWindowProps) {
    const { t } = useTranslation();
    const handleClose: MouseEventHandler<HTMLButtonElement> = (e) => {
        e.stopPropagation();
        onClose();
    };

    return (
        <div className={style.deletePastVoteWindowWrapper} onMouseDown={(e) => e.stopPropagation()}>
            <div className={style.deletePasteVoteWindow}>
                <div className={style.closeIconWrapper}>
                    <button
                        className={style.deletePasteVoteWindowClose}
                        type="button"
                        onMouseDown={handleClose}
                    >
                        <CloseIcon className={style.closeIcon} />
                    </button>
                </div>
                <div className={style.deletePastVoteHeader}>
                    <p>{t("deleteVote.title")}</p>
                </div>
                <div className={style.deletePastVoteTextWrapper}>
                    <p>{t("deleteVote.description", { name })}</p>
                </div>
                <div className={style.deletePastVoteButtonsWrapper}>
                    <button
                        className={style.deletePastVoteBtnAccept}
                        type="button"
                        onMouseDown={(e) => {
                            e.stopPropagation();
                            onDelete();
                        }}
                    >
                        {t("deleteVote.delete")}
                    </button>
                    <button
                        className={style.deletePastVoteBtnCancel}
                        type="button"
                        onMouseDown={handleClose}
                    >
                        {t("deleteVote.cancel")}
                    </button>
                </div>
            </div>
        </div>
    );
}
